// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__x4ui0","noInteraction":"EventWrapper_noInteraction__3ZC1F"};